/* global axios */
import ApiClient from './ApiClient';

class CsatSurveysAPI extends ApiClient {
  constructor() {
    super('csat_surveys', { accountScoped: true });
  }

  formats() {
    return axios.get(`${this.url}/formats`);
  }
}

export default new CsatSurveysAPI();
